import { render, staticRenderFns } from "./roleslist.html?vue&type=template&id=5d719c07&scoped=true&external"
import script from "./roleslist.vue?vue&type=script&lang=js"
export * from "./roleslist.vue?vue&type=script&lang=js"
import style0 from "./roleslist.vue?vue&type=style&index=0&id=5d719c07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d719c07",
  null
  
)

export default component.exports